import {loaderInstanse} from "@soinproduction/kit/src/functions/scripts/loaderInstanse";

document.addEventListener("DOMContentLoaded", () => {
    const modalManager = window.modalManager;
    if (!modalManager) return;

    const thanksModalID = ajax_params?.modals?.success;
    const errorModalID = ajax_params?.modals?.error;

    console.log(errorModalID,thanksModalID)

    const applyPhoneMask = (root = document, pattern = '+1 (___) ___ ____') => {
        const setCursor = (pos, el) => {
            el.focus();
            if (el.setSelectionRange) el.setSelectionRange(pos, pos);
            else if (el.createTextRange) {
                const r = el.createTextRange();
                r.collapse(true);
                r.moveEnd('character', pos);
                r.moveStart('character', pos);
                r.select();
            }
        };

        function createMask(e) {
            const matrix = pattern;
            let i = 0;
            const def = matrix.replace(/\D/g, '');
            let val = this.value.replace(/\D/g, '');
            if (def.length >= val.length) val = def;

            this.value = matrix.replace(/./g, (a) =>
                /[_\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? '' : a
            );

            if (e.type === 'blur') {
                if (this.value.length === 2) this.value = '';
            } else {
                setCursor(this.value.length, this);
            }
        }

        root.querySelectorAll('input[type="tel"]:not([data-mask-inited])').forEach((input) => {
            input.dataset.maskInited = '1';
            input.placeholder = pattern;
            input.addEventListener('input', createMask);
            input.addEventListener('focus', createMask);
            input.addEventListener('blur', createMask);
        });
    };

    // applyPhoneMask(modal);

    document.querySelectorAll(".wpcf7").forEach((wrapper) => {
        const submitBtn = wrapper.querySelector('button[type="submit"]');
        wrapper.setAttribute("data-loader", "false");

        if (submitBtn) {
            submitBtn.addEventListener("click", () => loaderInstanse(wrapper, true));
        }

        wrapper.addEventListener("wpcf7invalid", () => setTimeout(() => loaderInstanse(wrapper, false), 500), false);

        wrapper.addEventListener("wpcf7mailfailed", () => {
                modalManager.closeAllModals();
                loaderInstanse(wrapper, true);

                setTimeout(() => {
                    loaderInstanse(wrapper, false);
                    setTimeout(() => {
                        if (errorModalID) modalManager.openModal(`modal_${errorModalID}`);
                        setTimeout(() => modalManager.closeAllModals(), 3000);
                    }, 400);
                }, 400);
            },
            false
        );

        wrapper.addEventListener("wpcf7mailsent", () => {
                modalManager.closeAllModals();
                loaderInstanse(wrapper, true);

                setTimeout(() => {
                    loaderInstanse(wrapper, false);
                    setTimeout(() => {
                        if (thanksModalID) modalManager.openModal(`modal_${thanksModalID}`);
                        setTimeout(() => modalManager.closeAllModals(), 3000);
                    }, 400);
                }, 400);
            },
            false
        );
    });

    modalManager.on("beforeClose", ({modal}) => {
        if (!modal) return;
        modal.querySelectorAll(".wpcf7").forEach((wrap) => loaderInstanse(wrap, false));
    });
});
